<div class="content" [ngSwitch]="key">
	<div class="date spacing" *ngSwitchCase="'date'"
		 [class.active]="active">
		<div class="content-wrapper">
			<shared-icon-sprite svgId="calendar-date-2-2" class="icon"></shared-icon-sprite>
			<span class="c-ml-1">{{ value | date }}</span>
		</div>
	</div>
	<div class="file spacing" *ngSwitchCase="'fileName'">
		<span class="content-wrapper">
			<shared-icon-sprite svgId="attach" class="icon c-mr-1" iconClass="icon-primary"></shared-icon-sprite>
			<a (click)="downloadFile(content.id, content.fileName)">{{ content.fileName }}</a>
		</span>
	</div>
	<div class="text spacing" *ngSwitchCase="'textContent'"
		 [class.active]="active">
		<shared-ellipsis [content]="value"></shared-ellipsis>
	</div>
	<div class="selected spacing" *ngSwitchCase="'selected'"
		 [class.active]="active">
		<ng-container *ngIf="!isArray(value)">
			<shared-ellipsis [content]="value"></shared-ellipsis>
		</ng-container>
		<ul class="mb-0 pl-3" *ngIf="isArray(value)">
			<ng-container *ngFor="let v of value, let i = index">
				<li *ngIf="v">
					<shared-ellipsis [content]="v?.key ? v.key : v"></shared-ellipsis>
					<ng-container *ngFor="let selectedDesc of content.selectedDescriptionArray">
						<div class="description" *ngIf="content.selectedDescriptionArray && selectedDesc?.description?.length">
							<span *ngIf="(selectedDesc.option === v) || (selectedDesc.option === v?.key)" class="c-mr-1">
								<i class="fa-solid fa-angles-right"></i>
								<shared-ellipsis [content]="selectedDesc.description"></shared-ellipsis>
							</span>
						</div>
					</ng-container>
				</li>
			</ng-container>
		</ul>
	</div>
	<div class="selected spacing" *ngSwitchCase="'selectedDescription'"
		 [class.active]="active">
		<div class="description" *ngIf="value?.length">
			<span class="c-mr-1 d-flex align-items-center"><i class="fa-solid fa-angles-right"></i>
				<shared-ellipsis class="c-ml-1" [content]="value"></shared-ellipsis>
			</span>
		</div>
	</div>
	<div *ngSwitchCase="'otherOption'">
		<div><shared-ellipsis [content]="value"></shared-ellipsis></div>
	</div>
</div>
